/**
 * AboutSLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AboutSLSiteHeaderLanguages
 */

import { useAboutSLSiteHeaderLanguagesLogic } from '@/hooks/traits/useAboutSLSiteHeaderLanguagesLogic';
import type { AboutSLSiteHeaderLanguagesConfig } from '@/hooks/traits/useAboutSLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AboutSLAboutView as AboutSLAboutViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface AboutSLSiteHeaderLanguagesViewProps {
  config?: Partial<AboutSLSiteHeaderLanguagesConfig>;
}

export function AboutSLSiteHeaderLanguagesView({ config: propsConfig }: AboutSLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAboutSLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AboutSLAboutView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AboutSL" trait="AboutSLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu items={Array.isArray(([{ href: "/about" as const, label: "English" as const, code: "en" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/about" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/about" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), id: (getNestedValue(entry, "code") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) ? (((([{ href: "/about" as const, label: "English" as const, code: "en" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/about" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/about" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), id: (getNestedValue(entry, "code") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} trigger={<Button label={String(__locale.toUpperCase())} size="sm" variant="ghost" icon="globe" />} position="bottom-end" className={((([{ label: "English" as const, code: "en" as const, href: "/about" as const }, { code: "ar" as const, href: "/ar/about" as const, label: "العربية" as const }, { label: "Slovenščina" as const, href: "/sl/about" as const, code: "sl" as const }]).length === 0)) ? "hidden" : ""} />) : null}
    </TraitScopeProvider>
  );
}

export default AboutSLSiteHeaderLanguagesView;
